<template>
  <div v-loading="loading" ref="courseRef" class="course-center">
    <div class="content">
      <div ref="scollContent" class="right">
        <el-scollbar class="sub-content">
          <div
            v-for="(item, index) in currentCourseDataList"
            :key="index"
            class="course-li"
            @click="goDetail(item)"
          >
            <div v-if="item.isOwner === 0" class="course-zhezhao" />
            <div class="div-cover-img">
              <img :src="item.image" class="cover-img" />
            </div>

            <div class="sub-middle-li">
              <div class="course-name">{{ item.title }}</div>
              <div class="course-time">{{ item.level }}</div>
              <div class="other-info">
                  <img :src="Number(item.is_bixiu)===1?require('@/assets/coursebottom1.png'):require('@/assets/coursebottom2.png')">
                  {{ Number(item.is_bixiu)===1?'必修课程':'选修课程' }}
                  <div style="position: absolute;right:10px;bottom: 0px;color:#313131;font-weight: 700;" v-if="Number(item.is_finish) === 1">已完成</div>
                </div>
            </div>
          </div>
          <img
            v-if="currentCourseDataList.length === 0"
            style="width:251px;height:200px;margin-left:calc(50% - 125px);margin-top:150px;"
            src="@/assets/noData.png"
          />
          <div
            v-if="currentCourseDataList.length === 0"
            style="width:251px;height:200px;margin-left:calc(50% - 125px);color:#666666;font-size:16px;font-weight:400;text-align:center"
          >
            暂无内容
          </div>
        </el-scollbar>
        <el-pagination
          v-if="currentCourseDataList.length != 0"
          :current-page="page"
          :page-sizes="[20, 50, 100]"
          :page-size="perPage"
          :total="Number(total)"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Loading, Pagination, Scrollbar, Message } from "element-ui";
import { mapState } from "vuex";

Vue.use(Loading);
export default {
  components: {
    "el-pagination": Pagination,
    "el-scollbar": Scrollbar,
  },
  props:{
    type:{
      type:[Number, String],
      default: () => 1
    }
  },
  filters: {
    formatCourseImg(val) {
      if (val === "") {
        // eslint-disable-next-line global-require
        return require("@/assets/fengmian.png");
      }
      // eslint-disable-next-line no-undef
      return val;
    },
    formatNum(val) {
      return Number(val) > 999 ? "999+" : val;
    },
    formatScore(val) {
      return Number(val).toFixed(1);
    },
  },
  data() {
    return {
      // 列表请求的参数
      isPaging: true,
      page: 1,
      perPage: 20,
      total: 0,
      belong: 2,
      // 一行展示多少
      geshu: 4,
      contentLeft: -10,
      loading: false,
      currentCourseDataList: []
      
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {
  },
  async mounted() {
    this.getData();
  },
  destroyed() {
  },
  methods: {
    async getData() {
      this.loading = true;
      const params = {
        page: this.page,
        limit: this.perPage,
        type: Number(this.type)-1,
      };
      const res = await this.$http.get("/api/course/getUserStudyProgress", params);
      this.loading = false
      if (res.data) {
        this.currentCourseDataList = res.data;
        this.total = res.total;
      }
      if(res.pop){
        Message.info(res.pop)
      }
    },
    handleSizeChange(val) {
      this.perPage = val;
      this.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
    // 跳转至详情页
    goDetail(item) {
      this.$router.push(`/courseDetail?id=${item.id}&type=${this.type}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.sub-header {
  position: relative;
  width: 100%;
  height: 100px;
  background-color: #fff;
  color: #999999;
  line-height: 45px;
  padding-left: 0px;
  margin: auto;
  .showIcon {
    font-size: 22px;
    vertical-align: middle;
  }
  span {
    vertical-align: middle;
    font-size: 14px;
    margin-left: 40px;
    cursor: pointer;
  }
  .search {
    width: 200px;
    position: absolute;
    right: 100px;
    top: 0px;
    z-index: 999;
    ::v-deep.el-input__inner {
      height: 32px;
      padding: 2px 25px;
      height: 30px;
      border: 1px solid #dbdbdb;
      border-radius: 5px;
      color: #b3b3b3;
      font-size: 14px;
    }
    .el-input__icon {
      line-height: 30px;
    }
  }
}
.course-center {
  width: 100%;
  height: 100%;
  background: #fff;
  height: 100%;
  overflow: auto;
  .content {
    width: 100%;
    margin: auto;
    background: #fff;
    font-size: 0px;
    .class-menu {
      ::v-deep.el-tree {
        width: calc(100% - 20px);
        margin-left: 10px;
        overflow-x: auto;
        padding-bottom: 15px;
      }

      ::v-deep.el-tree > .el-tree-node {
        display: inline-block;
        min-width: 100%;
      }
      ::v-deep.el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #4c85ff;
        border-color: #4c85ff;
      }
      ::v-deep.el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #4c85ff;
      }
      .title {
        color: #333333;
        font-weight: bold;
        font-size: 15px;
        padding: 26px 10px;
        position: relative;
        .ver-line {
          display: inline-block;
          vertical-align: middle;
          width: 5px;
          height: 16px;
          background-color: #4c85ff;
        }
        .name {
          vertical-align: middle;
          display: inline-block;
          margin-left: 10px;
        }
      }
    }
    .right {
      display: inline-block;
      vertical-align: top;
      position: relative;
      height: 100%;
      width: 100%;

      .sub-content {
        // width: calc(100% + 30px);
        min-height: calc(100vh - 420px);
        padding-bottom: 10px;
        // overflow-y: hidden;
        ::v-deep .el-scrollbar__wrap {
          overflow-x: auto;
        }
        ::v-deep.el-scrollbar__bar.is-vertical {
          display: none;
        }
        .course-li {
          width: 215px;
          height: 225px;
          border-radius: 2px;
          // display: inline-block;
          margin-right: 22px;
          margin-bottom: 25px;
          border: 1px solid #f2f1f1;
          background-color: #fff;
          cursor: pointer;
          overflow: hidden;
          vertical-align: top;
          position: relative;
          box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
          .course-zhezhao {
            width: 100%;
            height: 210px;
            position: absolute;
            left: 0px;
            top: 0px;
            background: #b5b4b4;
            opacity: 0.6;
          }
          .div-cover-img {
            width: 100%;
            height: 123px;
            overflow: hidden;
            .cover-img {
              width: 100%;
              height: 123px;
              transition: transform 1s;
              &:hover {
                transform: scale(1.15);
              }
            }
          }
          .sub-middle-li {
            height: 68px;
            width: 100%;
            // border-bottom:1px solid rgba(242,241,241,1);
            .course-name {
              padding: 12px 9px;
              color: #313131;
              font-weight: bold;
              font-size: 14px;
              text-overflow: ellipsis;
              font-family: Source Han Sans CN;
              overflow: hidden;
              white-space: nowrap;
            }
            .course-time {
              font-size: 12px;
              position: relative;
              padding-left: 9px;
              padding-bottom: 8px;
              color: #a3a3a3;
              height: 15px;
              overflow: hidden;
            }
            .other-info {
              color: #313131;
              font-size: 12px;
              position: relative;
              padding-left: 9px;
              margin-top: 8px;
              img {
                width: 12px;
                vertical-align: middle;
              }
              ::v-deep.el-rate {
                display: inline-block;
                vertical-align: middle;
                // position: absolute;
                // top:-3px;
                // right:25px;
              }
              ::v-deep.el-rate__icon {
                margin-right: 2px;
              }
              .rate {
                position: absolute;
                top: -4px;
                right: 10px;
                span {
                  vertical-align: middle;
                  color: #fd583e;
                  margin-left: 5px;
                }
              }
            }
          }
          .sub-bottom-li {
            height: 34px;
            width: 100%;
            border-bottom: 1px solid rgba(242, 241, 241, 1);
            .lecturer-info {
              position: relative;
              img {
                border-radius: 50%;
                vertical-align: middle;
                height: 20px;
                margin-left: 9px;
                margin-top: 7px;
              }
              span {
                color: #333333;
                font-size: 12px;
                font-weight: 400;
                vertical-align: middle;
                display: inline-block;
                width: 85px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-top: 7px;
                margin-left: 12px;
              }
              div {
                position: absolute;
                top: 11px;
                right: 5px;
              }
              i {
                color: #a6a6a6;
                font-size: 12px;
              }
              .i-1 {
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
}

.sear-btn {
  display: inline-block;
  vertical-align: middle;
  color: #326ed4;
  background-color: #f1f1f1;
  border-radius: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  height: 24px;
  line-height: 24px;
  padding: 0px 10px;
  min-width: 92px;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
}
.active {
  color: #fff !important;
  background-color: #024cd9 !important;
}
.active2 {
  border-bottom: 2.5px solid #003999 !important;
  color: #313131 !important;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  height: 42px;
  line-height: 42px;
  padding: 0px !important;
}
.blo {
  color: #222;
  font-size: 13px;
  margin-left: 0px;
  width: 100%;
  padding: 0 20px;

  span {
    display: inline-block;
    vertical-align: middle;
    margin-right: 0px;
  }
}

::v-deep {
  .el-dialog__headerbtn {
    display: none !important;
  }
  .el-dialog {
    width: 300px !important;
  }
}
.price-txt {
  text-align: center;
  padding-top: 20px;
  font-size: 20px;
}
::v-deep {
  .el-scrollbar__view {
    display: flex;
    flex-wrap: wrap;
  }
}
::v-deep {
   .is-checked {
    .el-checkbox__inner{
      background-color: #024cd9 !important;
      border-color: #024cd9 !important;
    }
   }
}
.select-year{
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
